import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { type IServerTimeService } from './server-time.types';

dayjs.extend(utc);
dayjs.extend(timezone);

export class ServerTimeService implements IServerTimeService {
  #serverTimeZone = 'Asia/Nicosia';

  #offset: number = 0;

  get serverTimeZoneOffset(): number {
    return dayjs.tz(this.now(), this.#serverTimeZone).utcOffset();
  }

  sync(serverTimestampInMilliseconds: number) {
    const clientNow = Date.now();

    this.#offset = serverTimestampInMilliseconds - clientNow;
  }

  now(): number {
    return Date.now() + this.#offset;
  }
}
